import { Modal } from "react-bootstrap";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { ReactElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface HelpModalWidgetProps {
    content: ReactElement;
    title?: string;
    icon: IconName;
    show: boolean;
    onHide: () => void;
}

export function HelpModalWidget(props: HelpModalWidgetProps) {
    return (
        <Modal centered scrollable animation={false} show={props.show} onHide={props.onHide} id="help-modal" aria-labelledby="help-modal">
            <Modal.Header closeButton className="align-items-center border-bottom gap-2 flex-row">
                <FontAwesomeIcon icon={["fas", props.icon]} className="text-gray-600" style={{ fontSize: "1.25rem" }} />
                <Modal.Title id="help-modal-title">{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="mb-3">{props.content}</Modal.Body>
        </Modal>
    );
}
